import templateSMS from './sms-template'
import messagePush from './message-push'

export default {
  namespaced: true,
  modules: {
    templateSMS,
    messagePush,
  },
}
